import { Icon } from "@iconify/react/dist/iconify.js";

const OrdersHeader = ({ animationStates, viewMode, handleViewModeToggle, customerId }) => {
    const isKronk = customerId === 'kronk';
    
    return (
        <div className={`flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 w-full transition-all duration-700 ease-out-in ${
            animationStates.header
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 -translate-y-4'
        }`}>
            <div className="flex flex-col gap-1 items-start w-full">
                <h1 className="header-textbox">
                    <Icon icon="material-symbols:order-approve-outline" className="header-icon" />
                    <span className="text-font-primary font-semibold">Orders</span>
                </h1>
                <p className="text-font-secondary text-sm sm:text-base">
                    View all orders placed during calls
                </p>
            </div>
            {/* View Mode Toggle - Hidden for kronk */}
            {!isKronk && (
                <div className="flex p-1 w-fit">
                    <button
                        onClick={() => handleViewModeToggle('confirmedOnly')}
                        className={`flex flex-row items-center gap-1 px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                            viewMode === 'confirmedOnly'
                                ? 'bg-primary-20 text-primary border-primary-30 border'
                                : 'text-font-secondary hover:text-primary'
                        }`}
                    >
                        <Icon icon="mdi:check-all" className="text-xl" />
                        <span className={`${viewMode === 'confirmedOnly' ? 'text-font-primary font-semibold' : 'text-font-secondary'}`}>Confirmed Only</span>
                    </button>
                    <button
                        onClick={() => handleViewModeToggle('allLogs')}
                        className={`flex flex-row items-center gap-1 px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                            viewMode === 'allLogs'
                                ? 'bg-primary-20 text-primary border-primary-30 border'
                                : 'text-font-secondary hover:text-primary'
                        }`}
                    >
                        <Icon icon="material-symbols:list-rounded" className="text-xl" />
                        <span className={`${viewMode === 'allLogs' ? 'text-font-primary font-semibold' : 'text-font-secondary'}`}>All Logs</span>
                    </button>
                </div>
            )}
        </div>
    );
};

export default OrdersHeader;
